module.exports = {
  PENDING: 'pending',
  CLOSED: 'closed',
  RATED: 'rated',
};
